/** @file Shared modal primitive. */
import { h, clear } from "./dom.js";

/**
 * @param {(close: (result?: any) => void) => HTMLElement} contentFactory
 * @returns {Promise<any>}
 */
export function openModal(contentFactory) {
  return new Promise((resolve) => {
    const backdrop = h("div", { class: "hb-modal-backdrop" });
    const card = h("div", { class: "hb-modal-card" });
    backdrop.appendChild(card);

    let resolved = false;
    /** @param {any} result */
    const close = (result) => {
      if (resolved) {
        return;
      }
      resolved = true;
      backdrop.remove();
      document.removeEventListener("keydown", onKey);
      resolve(result ?? null);
    };

    const onKey = (/** @type {KeyboardEvent} */ e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        close(null);
      }
    };
    document.addEventListener("keydown", onKey);
    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) {
        close(null);
      }
    });

    clear(card);
    card.appendChild(contentFactory(close));
    document.body.appendChild(backdrop);
  });
}
